export default "__VITE_ASSET__B0VYW2Ud__"